import React from "react";

export const ClosedLock = () => {
  return (
    <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 6.02246H10.4881V13.6745H0V6.02246ZM1.18055 7.20302V12.494H9.30756V7.20302H1.18055Z"
        fill="#113357"
      />
      <path
        d="M5.24508 10.7192C5.69865 10.7192 6.06634 10.3515 6.06634 9.89792C6.06634 9.44435 5.69865 9.07666 5.24508 9.07666C4.79152 9.07666 4.42383 9.44435 4.42383 9.89792C4.42383 10.3515 4.79152 10.7192 5.24508 10.7192Z"
        fill="#113357"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.05404 1.18055C4.56681 1.18055 4.09328 1.38361 3.73944 1.75533C3.38465 2.12803 3.18055 2.63947 3.18055 3.17847V7.004H2V3.17847C2 2.34462 2.31505 1.53942 2.88436 0.941358C3.45461 0.34231 4.23441 0 5.05404 0C5.87367 0 6.65348 0.34231 7.22373 0.941358C7.79304 1.53942 8.10809 2.34462 8.10809 3.17847V6.76875L6.92753 6.76875V3.17847C6.92753 2.63947 6.72343 2.12803 6.36865 1.75533C6.01481 1.38361 5.54128 1.18055 5.05404 1.18055Z"
        fill="#113357"
      />
    </svg>
  );
};
